import moment from "moment";
import { DATE_FORMAT_MONTH_YEAR } from "../../common/constants/";

export default class DateUtils {
    convertTimestamp(timestamp) {
        const seconds = this.normalizeUnixSeconds(timestamp);
        if (seconds === null) {
            return timestamp;
        }
        var d = new Date(seconds * 1000), // Convert the passed timestamp to milliseconds
        yyyy = d.getFullYear(),
        mm = ("0" + (d.getMonth() + 1)).slice(-2), // Months are zero based. Add leading 0.
        dd = ("0" + d.getDate()).slice(-2), // Add leading 0.
        hh = d.getHours(),
        h = hh,
        min = ("0" + d.getMinutes()).slice(-2), // Add leading 0.
        ampm = "AM",
        time;

        if (hh > 12) {
        // h = hh - 12;
        // ampm = "PM";
        } else if (hh === 12) {
        h = 12;
        // ampm = "PM";
        } else if (hh === 0) {
        h = 12;
        }

        // ie: 2013-02-18, 8:35 AM
        time = dd + "/" + mm + "/" + yyyy + ", " + h + ":" + min;
        // + " " + ampm;

        return time;
    }

    convertTimestampToOnlyDate(timestamp) {
        const seconds = this.normalizeUnixSeconds(timestamp);
        if (seconds === null) {
            return timestamp;
        }
        var d = new Date(seconds * 1000), // Convert the passed timestamp to milliseconds
        yyyy = d.getFullYear(),
        mm = ("0" + (d.getMonth() + 1)).slice(-2), // Months are zero based. Add leading 0.
        dd = ("0" + d.getDate()).slice(-2), // Add leading 0.
        time = dd + "/" + mm + "/" + yyyy;

        return time;
    }

    convertTimeStampToDate(timeStamp, dateFormat) {
        const seconds = this.normalizeUnixSeconds(timeStamp);
        if (seconds !== null) {
            const newDateFormat = dateFormat ? dateFormat : DATE_FORMAT_MONTH_YEAR;
            return moment.unix(seconds).format(newDateFormat);
        }

        return timeStamp;
    }

    /**
     * API serializers often return Unix seconds; some callers pass ms.
     * Treating seconds as ms yields Jan 1970 dates (e.g. 21/01/1970).
     */
    normalizeUnixSeconds(timeStamp) {
        if (timeStamp === null || timeStamp === undefined || timeStamp === "") {
            return null;
        }
        if (typeof timeStamp === "string" && isNaN(timeStamp)) {
            return null;
        }
        const numeric = Number(timeStamp);
        if (!Number.isFinite(numeric) || numeric <= 0) {
            return null;
        }
        // Milliseconds since epoch are >= 1e12 for dates after ~2001.
        if (numeric >= 1e12) {
            return Math.floor(numeric / 1000);
        }
        return Math.floor(numeric);
    }

    convertDateToTimeStamp(date) {
        if (date instanceof Date) {
        return Math.floor(date.getTime() / 1000);
        }

        return date;
    }

    convertDateToDate(date, dateFormat) {
        const newDateFormat = dateFormat ? dateFormat : DATE_FORMAT_MONTH_YEAR;

        // Compact API dates (e.g. D&B "20241231") must not be treated as Unix seconds.
        if (date !== null && date !== undefined && /^\d{8}$/.test(String(date))) {
            const compactDate = moment(String(date), "YYYYMMDD", true);
            if (compactDate.isValid()) {
                return compactDate.format(newDateFormat);
            }
        }

        const seconds = this.normalizeUnixSeconds(date);
        if (seconds !== null) {
            return moment.unix(seconds).format(newDateFormat);
        }
        if (moment(date).isValid()) {
            return moment(date).format(newDateFormat);
        }

        return date;
    }

    getCurrentDate = () => {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        const yyyy = today.getFullYear();
        return yyyy + "-" + mm + "-" + dd;
    };

    getCurrentDateInTimestamp = () => {
        return Math.floor(new Date().getTime() / 1000);
    };

    getDiffInDays = (date1, date2) => {
        const startDate = new Date(date1);
        const endDate = new Date(date2);

        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999);
        
        const oneDay = 1000 * 60 * 60 * 24;
        const differenceInMs = Math.abs(endDate.getTime() - startDate.getTime());
        const daysDifference = Math.floor(differenceInMs / oneDay);

        return Math.round(daysDifference);
    }

    isLeapYear = (yearDate) => {
        const year = (new Date(yearDate)).getFullYear();

        return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
    }
}
